<template>
  <div class="ticket-container">
    <!-- 可滚动留言区 -->
    <div class="ticket-scroll">
      <div
        v-for="item in messages"
        :key="item.id"
        :class="
          item.is_from_kf ? 'ticket-item ticket-background' : 'ticket-item'
        "
      >
        <div class="ticket-header">
          <span :class="['ticket-sender', item.sender]">
            {{
              item.is_from_kf ? '客服' : item.parent_name + '-' + item.class_no
            }}
          </span>
          <span class="ticket-time">{{
            moment(item.createdTime).format('YYYY-MM-DD HH:mm')
          }}</span>
        </div>
        <div class="ticket-content">{{ item.message }}</div>
      </div>
    </div>

    <!-- 底部输入框 -->
    <div class="ticket-input">
      <textarea
        class="input"
        v-model="input"
        placeholder="请输入留言内容..."
      ></textarea>
      <button class="send-btn" @click="sendMessage" :disabled="isLoading">
        <span v-if="!isLoading">提交</span>
        <span v-else class="loading-spinner"></span>
      </button>
    </div>
    <button class="fab" @click="goToList">
      ≡
    </button>
  </div>
</template>

<script>
import moment from 'moment';
import { portalUrl } from '../static/config';
export default {
  name: 'ChatPage',
  data() {
    return {
      input: '',
      messages: [],
      isLoading: false,
    };
  },
  mounted() {
    this.languageId = this.$route.params.language_id;
    this.axios
      .get(
        `${portalUrl}language/students/fetch_all_language_messages?language_id=${this.languageId}&from_kefu=true`
      )
      .then((res) => {
        if (res.data.success) {
          this.messages = res.data.data;
          this.scrollToBottom();
        }
      });
  },

  methods: {
    moment,
    sendMessage() {
      if (!this.input.trim()) return;
      this.isLoading = true;
      this.axios
        .post(`${portalUrl}language/students/kf_leave_message`, {
          language_id: this.languageId,
          message: this.input,
        })
        .then((res) => {
          this.isLoading = false;
          if (res.data.success) {
            this.messages.push(res.data.data);
            this.input = '';
            this.scrollToBottom();
          }
        });
    },
    scrollToBottom() {
      this.$nextTick(() => {
        // 自动滚动到底部
        const scrollEl = this.$el.querySelector('.ticket-scroll');
        scrollEl.scrollTop = 1000000;
      });
    },
    goToList() {
      const firstMessage = this.messages[0];
      if (firstMessage) {
        const phone = firstMessage.kefu_phone;
        this.$router.replace({ name: 'all_messages', params: { phone } });
      }
      // 跳转到留言列表
    },
  },
};
</script>

<style scoped>
.ticket-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #f5f6fa;
  width: 100%;
  max-width: 500px;
  position: relative;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

/* 可滚动区域，必须设置 flex: 1 + overflow-y */
.ticket-scroll {
  flex: 1;
  padding: 10px;
  box-sizing: border-box;
  overflow-y: auto;
}

.ticket-item {
  background: #ebebeb;
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.ticket-background {
  background-color: #accdfa;
}

.ticket-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.ticket-sender {
  font-weight: bold;
  font-size: 14px;
}

.ticket-sender.user {
  color: #666;
}

.ticket-sender.agent {
  color: #007bff;
}

.ticket-time {
  font-size: 12px;
  color: #333;
}

.ticket-content {
  font-size: 15px;
  color: #333;
  line-height: 1.6;
  text-align: left;
}

.ticket-input {
  border-top: 1px solid #e5e5e5;
  background: #fff;
  padding: 10px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 -1px 6px rgba(0, 0, 0, 0.05);
}

.input {
  min-height: 60px;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 8px;
  font-size: 14px;
  margin-bottom: 8px;
  background: #f9f9f9;
  resize: none;
}

.send-btn {
  position: relative;
  padding: 8px 16px;
  background: #409eff;
  color: white;
  border-radius: 8px;
  border: none;
  cursor: pointer;
}

.send-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* 简单的 loading spinner */
.loading-spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.fab {
  position: absolute;
  bottom: 150px;
  right: 20px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: none;
  background: #007aff;
  color: #fff;
  font-size: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition: transform 0.1s ease-in-out, box-shadow 0.1s ease-in-out;
  z-index: 999;
}

.fab:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
}

.fab:active {
  transform: scale(0.95);
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
